import moment from "moment";

export const useResultsNewHook = () => {
  const formatQueryText = (query) => {
    let storyTitle = query; // query.substring(0, query.length - 30);
    return <div>{storyTitle}</div>;
    // return query.replace(/from dates .*$/g, " ").trim();
  };

  const convertBaseClip = (clip) => {
    var new_clip = {
      first_pub_date: moment(clip["video_timestamp"]?.["epoch_millis"]).format(
        "MMMM DD, YYYY"
      ),
      clip_id: clip["clip_id"],
      media_start_time: parseFloat(clip["video_start_time"]) / 1000,
      media_end_time: parseFloat(clip["video_end_time"]) / 1000,
      duration: parseFloat(clip["video_duration"]) / 1000,
      media_url: clip["video_s3_presigned_url"],
      media_thumbnail: clip["thumbnail_s3_presigned_url"],

      video_start_time: clip["video_start_time"],
      video_end_time: clip["video_end_time"],
      video_duration: clip["video_duration"],
      clip_duration:
        parseFloat(clip["video_end_time"] - clip["video_start_time"]) / 1000,
      video_s3_presigned_url: clip["video_s3_presigned_url"],
      thumbnail_s3_presigned_url: clip["thumbnail_s3_presigned_url"],
      caption: clip["video_caption"],

      location: clip["location"],
      timed_captions: clip["timed_captions"],
      guest_speakers: clip["guest_speakers"],
      summary: clip["summary"],
      moment_summary: clip["moment_summary"],
      program_name: clip["program_name"],
      video_s3_bucket: clip["video_s3_bucket"],
      video_s3_key: clip["video_s3_key"],
    };
    return new_clip;
  };

  const convertVoiceOverAudioClip = (clip) => {
    var new_clip = {
      clip_id: clip["clip_id"],
      duration: parseFloat(clip["audio_duration"]) / 1000,
      media_url: clip["audio_s3_presigned_url"],
      audio_duration: clip["audio_duration"],
      audio_s3_presigned_url: clip["audio_s3_presigned_url"],
      caption: clip["audio_caption"],
    };
    return new_clip;
  };

  const convertVoiceOverOverlayClip = (clip) => {
    var new_clip = {
      first_pub_date: moment(clip["video_timestamp"]?.["epoch_millis"]).format(
        "MMMM DD, YYYY"
      ),
      clip_id: clip["clip_id"],
      media_start_time: parseFloat(clip["video_start_time"]) / 1000,
      media_end_time: parseFloat(clip["video_end_time"]) / 1000,
      duration: parseFloat(clip["video_duration"]) / 1000,
      media_url: clip["video_s3_presigned_url"],
      media_thumbnail: clip["thumbnail_s3_presigned_url"],

      video_start_time: clip["video_start_time"],
      video_end_time: clip["video_end_time"],
      video_duration: clip["video_duration"],
      clip_duration:
        parseFloat(clip["video_end_time"] - clip["video_start_time"]) / 1000,
      video_s3_presigned_url: clip["video_s3_presigned_url"],
      thumbnail_s3_presigned_url: clip["thumbnail_s3_presigned_url"],
      caption: clip["video_caption"],

      location: clip["location"],
      timed_captions: clip["timed_captions"],
      guest_speakers: clip["guest_speakers"],
      summary: clip["summary"],
      moment_summary: clip["moment_summary"],
      program_name: clip["program_name"],
      overlay_start_time: clip["overlay_start_time"],
      overlay_end_time: clip["overlay_end_time"],
    };
    return new_clip;
  };

  const convertVoiceOverClip = (clip) => {
    let new_clip;
    new_clip = convertVoiceOverAudioClip(clip);
    let overlay_clips = clip.overlay_clips.map((item) =>
      convertVoiceOverOverlayClip(item)
    );
    new_clip.overlay_clips = overlay_clips;
    new_clip.id = clip["video_story_clip_id"];
    new_clip.alternate_clips = clip["alternate_clips"]
      ? clip["alternate_clips"]
      : [];
    return new_clip;
  };

  const convertPrimaryClip = (clip) => {
    var new_clip = convertBaseClip(clip);
    new_clip.id = clip["video_story_clip_id"];
    new_clip.caption = clip["narrative_text"];
    new_clip.alternate_clips = clip["alternate_clips"];
    return new_clip;
  };

  const convertAlternateClip = (clip) => {
    var new_clip = convertBaseClip(clip);
    new_clip.id = clip["video_story_clip_id"];
    return new_clip;
  };

  const convert_history_clips = (clips) => {
    // need to convert the clips from the format from the history call to the format the UI expects
    var newclips = [];
    clips.forEach((clip) => {
      var newclip = convertPrimaryClip(clip);
      clip["alternate_clips"].forEach((alt_clip) => {
        var new_alt_clip = convertAlternateClip(alt_clip);
        newclip["alternate_clips"].push(new_alt_clip);
      });
      newclips.push(newclip);
    });
    return newclips;
  };

  const convertToStoryline = (data) => {
    return {
      id: data.id,
      text: data.text,
      start_time: data.start_time,
      end_time: data.end_time,
    };
  };

  return {
    formatQueryText,
    convertBaseClip,
    convertVoiceOverAudioClip,
    convertVoiceOverOverlayClip,
    convertVoiceOverClip,
    convertPrimaryClip,
    convertAlternateClip,
    convert_history_clips,
    convertToStoryline,
  };
};
